// extracted by mini-css-extract-plugin
module.exports = {"polytopeContainer":"style_polytopeContainer__1Cg8g","constraint":"style_constraint__3mI6M","constrContainer":"style_constrContainer__DlEFP","icon":"style_icon__2boAW"};